import type { CityConfig } from "../city-template/types";

export const belgradeConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Belgrade",
  state: "Montana",
  stateAbbr: "MT",
  slug: "belgrade",
  route: "/belgrade",
  title: "Emergency Passport Belgrade, MT — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Belgrade, MT — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Belgrade, Bozeman, Gallatin County, and the BZN airport corridor. No Denver trip needed.",
  h1: "Emergency & Expedited Passport Services in Belgrade, MT",
  heroSubtitle: "BZN connection to Seattle departing next week? Gallatin Valley business travel to Canada? Montana State University study abroad starting soon? We help Belgrade residents — from Gallatin Valley families to Bozeman-Yellowstone International Airport travelers to MSU students and faculty — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20view%20of%20Belgrade%20Montana%20with%20the%20Bridger%20Mountains%20in%20background%20at%20golden%20sunset%2C%20small%20town%20main%20street%20with%20American%20flags%2C%20Gallatin%20Valley%20agricultural%20landscape%20with%20wheat%20fields%20and%20farmhouses%2C%20warm%20amber%20evening%20light%2C%20travel%20editorial%20photography%20with%20crisp%20detail%20and%20natural%20Western%20tones%2C%20no%20people%20visible&width=1800&height=700&seq=belgrade-hero-2026&orientation=landscape",
  heroImageAlt: "Belgrade Montana with Bridger Mountains and Gallatin Valley at golden sunset",
  geoPosition: "45.7768;-111.1770",
  geoPlacename: "Belgrade, Montana",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "Cherry Creek III, 3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
    distance: "Nearest regional passport agency — approximately 560 miles from Belgrade; impractical for Gallatin Valley residents",
  },
  nearbyCitiesZips: [
    { name: "Belgrade", zips: "59714" },
    { name: "Bozeman", zips: "59715, 59717, 59718, 59719" },
    { name: "Manhattan", zips: "59741" },
    { name: "Three Forks", zips: "59752" },
    { name: "Livingston", zips: "59047" },
    { name: "Big Sky", zips: "59716" },
    { name: "Ennis", zips: "59729" },
    { name: "Townsend", zips: "59644" },
  ],
  benefits: [
    { icon: "ri-flight-takeoff-line", title: "BZN Airport Gateway Expertise", desc: "Bozeman Yellowstone International Airport is Montana's busiest airport — right in Belgrade. We know BZN connections, airline timelines, and the exact passport timing Gallatin Valley travelers need." },
    { icon: "ri-building-2-line", title: "No Denver Trip Required", desc: "Denver Passport Agency is 560 miles from Belgrade. Our registered courier service handles everything remotely — no 9+ hour drive through Wyoming needed." },
    { icon: "ri-graduation-cap-line", title: "MSU Students & Faculty Support", desc: "Montana State University study abroad programs, research conferences, and faculty international travel — we help the Bobcat community get passports fast on academic timelines." },
    { icon: "ri-home-2-line", title: "Gallatin Valley Growing Community", desc: "One of Montana's fastest-growing areas — new residents, families, and professionals all need first-time and renewal passports. We serve the entire valley from Belgrade to Big Sky." },
  ],
  internalLinks: [
    { name: "Expedited passport in Bozeman, MT", route: "/bozeman" },
    { name: "Fast passport services in Butte, MT", route: "/butte" },
    { name: "Quick passport services in Helena, MT", route: "/helena" },
    { name: "Urgent passport services in Kalispell, MT", route: "/kalispell" },
    { name: "Montana passport services overview", route: "/montana" },
  ],
  fpcOfficeAddress: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
  fpcOfficeNote: "Fast Passport Center serves Belgrade via secure registered courier with direct access to the Denver Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without driving 560 miles to Colorado. Belgrade residents can ship from any UPS Store, FedEx Office, or post office location in the Gallatin Valley — including right near BZN airport.",
  fpcOfficeDistance: "Serving Belgrade, Bozeman, Manhattan, Three Forks, Big Sky, and all Gallatin County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Belgrade and the Gallatin Valley. From BZN airport corridor to downtown Bozeman, from Three Forks to the Big Sky resort community — we serve all of Gallatin County. Our courier service eliminates the need to drive 560 miles to Denver for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Belgrade and all Gallatin County communities including Bozeman, Manhattan, Three Forks, Big Sky, and the BZN airport area. We also serve Montana State University students and faculty who need expedited passports for study abroad and international academic travel.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Belgrade as simple as possible — with the speed Gallatin Valley families, BZN travelers, and MSU students need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you. Most Belgrade travelers start online and ship documents overnight — no office visit required.",
  mistakesIntro: "Belgrade and Gallatin Valley travelers encounter unique challenges — from BZN connection timing to MSU study abroad deadlines to growing family passport needs. Here are the most common mistakes we see.",
  testimonialsIntro: "Gallatin Valley travelers — from Belgrade families to BZN passengers to MSU students — trust us when their international travel plans are imminent and Denver is not an option.",
  faqIntro: "Have questions about expedited passports in Belgrade, MT? Here are the most common ones we hear from Gallatin County travelers.",
  statePageRoute: "/states/montana",
  statePageName: "Montana",
  servicesIntro: "Whether you need a renewal before a BZN connection to an international flight, an emergency passport for a last-minute business trip, or a first-time passport for a Gallatin Valley family vacation — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dojmt.gov/driving/",
  dmvLabel: "Montana Motor Vehicle Division — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins", "Life-or-death emergencies only", "Denver agency is 560 miles from Belgrade", "Completely impractical for Gallatin Valley residents"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "No Denver trip needed — entirely remote", "Ideal for BZN international connections", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service post office", "Good for planned MSU study abroad travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload shifts with government shutdowns", "In-person clerk appointment required in Belgrade or Bozeman", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "BZN flight connecting to Seattle for an international departure in 2 days? Business meeting in Vancouver tomorrow? Our emergency courier service gets it done — as fast as 24 hours for Belgrade travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Belgrade residents renew fast — no agency visit required. Perfect for Gallatin Valley families, BZN travelers, and Belgrade professionals heading abroad.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Belgrade residents through every step with clear instructions for the nearest Gallatin County acceptance facility.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require DS-64 and additional forms. We guide you through everything needed — so your BZN connection or MSU study abroad program is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions so your Belgrade family vacation or MSU student group trip abroad stays on track.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports so travel documents match reservations. Common for Gallatin Valley residents after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Bozeman-area business owners, MSU researchers, and consultants who travel while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Belgrade and Gallatin Valley travelers through the process so international plans stay on schedule.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Convenient for Gallatin Valley residents heading to Alberta.",
      bullets: ["Wallet-size convenience", "Land and sea crossings to Canada", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Belgrade MT", description: "Urgent passport processing for Belgrade Montana travelers with immediate BZN departure needs." },
    { name: "Expedited Passport Renewal Belgrade MT", description: "Fast passport renewal for Belgrade Montana residents with a previously-issued passport." },
    { name: "First-Time Passport Belgrade MT", description: "New passport application services for Belgrade Montana residents applying for their first passport." },
    { name: "Child Passport Belgrade MT", description: "Minor passport services for Belgrade Montana families with children under 16." },
    { name: "Name Change Passport Belgrade MT", description: "Passport name correction after marriage, divorce, or legal name changes for Belgrade residents." },
    { name: "Second Passport Belgrade MT", description: "Second passport services for Belgrade and Gallatin Valley frequent travelers and business professionals." },
  ],
  testimonials: [
    {
      name: "Tom & Rachel D.",
      location: "Belgrade",
      rating: 5,
      text: "We booked flights through BZN to Seattle connecting to Tokyo, then realized our passports expired. Fast Passport Center got them back in 5 days. Living near the airport doesn't help when you don't have a passport — this service saved our trip.",
      service: "Passport Renewal — Family",
    },
    {
      name: "Jenna K.",
      location: "MSU Student — Belgrade",
      rating: 5,
      text: "My study abroad program in Spain had a short acceptance-to-departure window. I had never had a passport before. They walked me through everything — the Belgrade post office visit, the forms, the timing. Passport arrived in 8 days.",
      service: "First-Time Passport — Student",
    },
    {
      name: "Mark S.",
      location: "Belgrade",
      rating: 5,
      text: "Business trip to Calgary booked on 4 days notice. The Bozeman passport office couldn't help, and Denver is 560 miles away. Fast Passport Center got my renewal done remotely in 3 business days. Incredible.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "The Wilson Family",
      location: "Belgrade",
      rating: 5,
      text: "We moved to the Gallatin Valley last year and needed first-time passports for the kids before a trip to Ireland. They made the whole process simple — guided us to the right acceptance facility and everything went smoothly.",
      service: "Child Passport — First Time",
    },
  ],
  facilities: [
    {
      id: "belgrade-1",
      name: "Belgrade Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "218 W Main St",
      city: "Belgrade",
      state: "MT",
      zip: "59714",
      phone: "(406) 388-4933",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Downtown Belgrade",
      website: "https://tools.usps.com/find-location.htm?location=1363137",
      websiteLabel: "USPS Location",
      notes: "Primary acceptance facility for Belgrade residents. Convenient for BZN airport area travelers. Passport photos available. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "belgrade-2",
      name: "Bozeman Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "32 E Babcock St",
      city: "Bozeman",
      state: "MT",
      zip: "59715",
      phone: "(406) 587-4572",
      hours: "Mon–Fri 9:00 AM – 4:30 PM (appointment required)",
      distance: "Bozeman — about 10 miles east of Belgrade",
      website: "https://tools.usps.com/find-location.htm?location=1363627",
      websiteLabel: "USPS Location",
      notes: "Largest USPS acceptance facility in Gallatin County. Passport photos available on-site. Regular hours — busiest during MSU student travel seasons (August, December, May).",
      icon: "ri-mail-line",
    },
    {
      id: "belgrade-3",
      name: "Gallatin County Clerk & Recorder",
      type: "County Clerk Passport Acceptance",
      address: "311 W Main St, Room 203",
      city: "Bozeman",
      state: "MT",
      zip: "59715",
      phone: "(406) 582-2121",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Bozeman — Gallatin County Courthouse",
      website: "https://www.gallatin.mt.gov/Departments/Clerk-Recorder",
      websiteLabel: "Gallatin County Clerk",
      notes: "County clerk passport acceptance at the courthouse in downtown Bozeman. Appointment recommended. Photo services not available — bring your own passport photo.",
      icon: "ri-government-line",
    },
    {
      id: "belgrade-4",
      name: "Manhattan Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "120 W Main St",
      city: "Manhattan",
      state: "MT",
      zip: "59741",
      phone: "(406) 284-3454",
      hours: "Mon–Fri 9:00 AM – 3:00 PM (call to confirm passport services)",
      distance: "Manhattan — about 10 miles west of Belgrade",
      website: "https://tools.usps.com/find-location.htm?location=1377626",
      websiteLabel: "USPS Location",
      notes: "Small post office serving Manhattan and western Gallatin County. Limited hours — call ahead to confirm passport acceptance availability.",
      icon: "ri-mail-line",
    },
    {
      id: "belgrade-5",
      name: "Three Forks Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "122 Main St",
      city: "Three Forks",
      state: "MT",
      zip: "59752",
      phone: "(406) 285-3545",
      hours: "Mon–Fri 9:00 AM – 3:00 PM (call to confirm passport services)",
      distance: "Three Forks — about 20 miles northwest of Belgrade",
      website: "https://tools.usps.com/find-location.htm?location=1388660",
      websiteLabel: "USPS Location",
      notes: "Serves Three Forks and Headwaters area. Very limited passport hours — call first to confirm availability.",
      icon: "ri-mail-line",
    },
    {
      id: "belgrade-6",
      name: "Livingston Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "120 N 3rd St",
      city: "Livingston",
      state: "MT",
      zip: "59047",
      phone: "(406) 222-1932",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Livingston — about 30 miles east of Belgrade via I-90",
      website: "https://tools.usps.com/find-location.htm?location=1377340",
      websiteLabel: "USPS Location",
      notes: "Serves Livingston and Paradise Valley communities. Alternative to Bozeman-area facilities when appointments are unavailable in Gallatin County.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Denver Passport Agency, 560 miles from Belgrade", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to Aurora, CO; 9+ hours each way from Belgrade", fpc: "Most Belgrade travelers ship documents overnight from home or local UPS" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — very strict proof of emergency", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay, even worse from rural Montana", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Practicality for Belgrade", agency: "560-mile drive to Denver — 9+ hours and $100+ gas each way", fpc: "Entirely remote — forms online, ship from Belgrade, passport arrives at your Gallatin County door" },
    { feature: "Who Can Use It", agency: "Strict eligibility — life-or-death emergency only with documentation", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but add Denver travel costs, missed work, overnight stay", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Gallatin Valley Context", agency: "No Gallatin-specific guidance — no BZN, MSU, or Bozeman expertise", fpc: "Full BZN/Gallatin knowledge — airport connections, MSU academic timelines, growing community needs" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming BZN Airport Has Passport Services",
      description: "BZN is Montana's busiest airport but has no passport acceptance or agency services. Many Belgrade residents arrive at the airport thinking they can get a passport on-site — they cannot. Our courier service processes your passport before you get to BZN.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Waiting Until After MSU Study Abroad Acceptance",
      description: "Montana State University students often wait until they are accepted into study abroad programs before applying for a passport. Acceptance-to-departure windows are often 4–6 weeks — barely enough time for standard processing. Start the passport process when you apply, not when you are accepted.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations at Local Stores",
      description: "Some Gallatin Valley pharmacies and big-box stores produce photos that fail State Department standards. We catch sizing, background, and lighting issues before they cause a rejection and delay.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Gallatin Valley families often overlook the DS-3053 consent form when one parent is unavailable. This is an automatic rejection — we guide you through it correctly the first time.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for BZN Connection Timing",
      description: "BZN connects to Seattle, Denver, Salt Lake City, and Minneapolis before international flights. A passport issue discovered at the BZN check-in desk ends the trip before it starts. Check passport validity when you book, not when you pack.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order from your Belgrade home — just minutes from BZN." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist tailored to your travel situation — whether you are an MSU student or a Gallatin Valley family." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using overnight shipping. Most Belgrade clients ship from the UPS Store — no Denver trip needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "Your documents arrive at our processing center. We submit through reserved agency slots — so Gallatin Valley travelers never need to drive 560 miles to Denver." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Arrives at Your Door", description: "Your passport is completed within your selected timeframe and shipped directly to your Belgrade, Bozeman, or Gallatin County address. No agency visit. No Denver. Just your passport, on time." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Belgrade, Montana?", a: "We offer Belgrade-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel takes 5–10 business days. Because the nearest regional passport agency is in Denver (560 miles), our remote courier service is the most practical option for Gallatin Valley residents." },
    { q: "Does BZN airport offer passport services?", a: "No. Bozeman Yellowstone International Airport does not have any passport acceptance or agency services on-site. You need a valid passport before arriving at BZN for any international itinerary. Our courier service processes your passport and delivers it to your Belgrade or Bozeman address before your BZN departure." },
    { q: "Where can I get a passport acceptance near Belgrade?", a: "Belgrade has its own post office with passport acceptance on Main Street. Additional facilities are available at the Bozeman Main Post Office, Gallatin County Clerk & Recorder, Manhattan Post Office, and Livingston Post Office. We maintain a complete list with hours and appointment info." },
    { q: "Do MSU students in Belgrade need an acceptance visit for first passports?", a: "Yes. All first-time passport applicants — including MSU students living in Belgrade — must visit an acceptance facility in person. Belgrade Post Office and Bozeman Post Office both offer this service. We guide students to the nearest facility and provide a complete checklist." },
    { q: "What is the best price for expedited passport service in Belgrade?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping to and from our center, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. Best price guarantee included." },
    { q: "What documents do Belgrade applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Belgrade-specific checklist." },
    { q: "Can I get a passport photo in Belgrade?", a: "Yes. Belgrade Post Office offers on-site passport photos. CVS, Walgreens, and Costco in nearby Bozeman (10 minutes away) also provide passport photo services. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How far is the nearest passport agency from Belgrade?", a: "The Denver Passport Agency is approximately 560 miles from Belgrade — about a 9-hour drive via I-90 to Buffalo, WY and then south on I-25. For most Gallatin Valley residents, this is completely impractical. Our courier service processes remotely so you never leave Montana." },
    { q: "Can you help with study abroad passports for MSU students?", a: "Yes. We regularly assist Montana State University students with first-time passports for study abroad programs. The acceptance facility requirement is the same as any other first-time applicant — we help students find appointments at Belgrade or Bozeman acceptance facilities that work with their class schedules." },
    { q: "What if I'm flying out of BZN and realize my passport is expired?", a: "Do not go to BZN without a valid passport — you will be denied boarding for international itineraries. Contact us immediately. We have processed emergency renewals in as fast as 3 business days for BZN travelers. The sooner you contact us, the more options we have." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Belgrade Residents",
    intro: "Belgrade's unique position as the gateway to Montana's busiest airport — combined with Gallatin Valley growth and MSU proximity — creates distinct passport timing needs. Here's what Belgrade travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "BZN — Bozeman Yellowstone International Airport",
        subtitle: "Montana's busiest airport, right in Belgrade",
        description: "BZN is literally in Belgrade — just minutes from downtown. It connects to Seattle, Denver, Salt Lake City, Minneapolis, Chicago, Dallas, Los Angeles, San Francisco, and more. For international travel, BZN passengers connect through these hubs before flying overseas. The airport's rapid growth — now serving over 2 million passengers annually — means more Belgrade residents and visitors need passports than ever before.",
        tip: "BZN international connections mean your passport must be valid at Belgrade check-in, not just at your international gateway. American, Delta, United, and Alaska Airlines all require valid passport documentation at the first departure airport.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "Montana State University — Study Abroad & Academic Travel",
        subtitle: "MSU's global programs create concentrated passport demand",
        description: "Montana State University in nearby Bozeman sends hundreds of students abroad each year through exchange programs, faculty-led courses, and research collaborations. Between MSU students living in Belgrade and faculty commuting from the valley, academic passport demand peaks in two windows: late fall (November–December for spring semester departures) and late spring (April–May for summer and fall departures).",
        tip: "MSU students should apply for passports when they apply to study abroad programs, not when accepted. Program acceptance letters often arrive 4–6 weeks before departure — barely enough time even with expedited processing.",
      },
      {
        icon: "ri-building-2-line",
        title: "Gallatin Valley Growth & New Residents",
        subtitle: "One of America's fastest-growing areas creates first-time passport demand",
        description: "The Belgrade-Bozeman corridor is one of the fastest-growing regions in the United States. New residents moving from out of state often need first-time Montana documentation changes alongside passport applications. Combined with the valley's tech sector growth, outdoor industry professionals, and remote workers, the demand for passport services has grown faster than local facilities can handle.",
        tip: "New Montana residents should update their driver's license to their Gallatin County address before applying for a passport. Mismatched addresses between ID and application can cause processing delays.",
      },
      {
        icon: "ri-compass-3-line",
        title: "Big Sky Resort & Seasonal Travel Patterns",
        subtitle: "World-class ski destination drives international visitor passport needs",
        description: "Big Sky Resort — about 45 minutes south of Belgrade — draws international visitors, seasonal workers, and second-home owners from around the world. International staff arriving for seasonal ski and summer jobs often need passport services during their Montana stays. Resort guests sometimes discover passport issues while in Big Sky that need resolution before their return international flights from BZN.",
        tip: "International travelers visiting Big Sky should check passport validity before arriving in Montana. If an issue surfaces during your stay, our courier service can process a renewal and deliver to your Big Sky or Belgrade address before your BZN departure.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Belgrade's BZN Advantage — And Its Passport Gap",
      description: "Living next to Montana's busiest airport is a travel advantage — but BZN offers no passport services. The gap between BZN's international connectivity and the lack of local passport processing creates the exact scenario where our courier service shines. Belgrade residents get BZN convenience for domestic connections, and our remote courier service for the passport they need before boarding.",
    },
  },
  destinations: {
    title: "Where Belgrade Travelers Go — And Why Passports Get Urgent",
    intro: "Belgrade's proximity to BZN and MSU creates diverse international travel patterns. Here are the most common destinations and urgency scenarios.",
    stats: [
      { stat: "40%", label: "of Belgrade expedited requests are BZN airport connection-related — domestic connection to international" },
      { stat: "2–3 Weeks", label: "average lead time from booking to international departure for Gallatin Valley travelers" },
      { stat: "560 Miles", label: "distance to Denver Passport Agency — our courier service bridges this completely" },
      { stat: "3 Days", label: "shortest turnaround for a Belgrade business traveler heading to Canada through BZN" },
    ],
    destinations: [
      { name: "Canada", context: "Calgary Stampede, Banff ski trips, Vancouver business travel, Alberta family visits from Belgrade via BZN connections", urgency: "Business trips and ski vacations booked 2–4 weeks out", icon: "ri-map-pin-2-line" },
      { name: "Europe", context: "MSU study abroad in Spain, Italy, Germany, UK; Gallatin Valley family heritage trips to Ireland and Scandinavia", urgency: "Study abroad deadlines fixed — need passport months before departure", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Caribbean", context: "BZN connections to Cancun, Cabo, and Puerto Vallarta through hubs; all-inclusive resort vacations", urgency: "Spring break bookings surge January–February", icon: "ri-map-pin-2-line" },
      { name: "Asia", context: "MSU engineering and research partnerships in Japan and South Korea; outdoor gear industry sourcing trips", urgency: "Research travel with fixed conference dates", icon: "ri-map-pin-2-line" },
      { name: "Australia & New Zealand", context: "Outdoor industry trade connections, ski season worker exchanges, MSU exchange programs", urgency: "Seasonal work contracts with 2–4 weeks from offer to departure", icon: "ri-map-pin-2-line" },
      { name: "South America", context: "MSU field research in Patagonia and Andes, adventure travel, outdoor guide seasonal work", urgency: "Research expedition dates fixed months in advance", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Montana Service Areas",
    crossLinksDesc: "We serve travelers across Big Sky Country with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Bozeman", route: "/bozeman" },
      { name: "Butte", route: "/butte" },
      { name: "Helena", route: "/helena" },
    ],
  },
  photoLocations: [
    { name: "Walmart Supercenter — Belgrade", address: "9300 Harmon St, Belgrade, MT 59714", hours: "Daily 7 AM – 11 PM", website: "https://www.walmart.com/" },
    { name: "CVS Pharmacy — Bozeman", address: "115 N 19th Ave, Bozeman, MT 59718", hours: "Daily 8 AM – 9 PM", website: "https://www.cvs.com/" },
    { name: "Costco Wholesale — Bozeman", address: "2505 Catron St, Bozeman, MT 59718", hours: "Call for photo center hours", website: "https://www.costco.com/" },
    { name: "Walgreens — Bozeman", address: "1400 N 19th Ave, Bozeman, MT 59718", hours: "Call for hours", website: "https://www.walgreens.com/" },
    { name: "The UPS Store — Bozeman", address: "1459 N 19th Ave, Bozeman, MT 59718", hours: "Call for hours", website: "https://www.theupsstore.com/" },
    { name: "FedEx Office — Bozeman", address: "1500 N 7th Ave, Bozeman, MT 59715", hours: "Call for hours", website: "https://www.fedex.com/" },
    { name: "Walmart Supercenter — Bozeman", address: "1500 N 7th Ave, Bozeman, MT 59715", hours: "Daily 7 AM – 11 PM", website: "https://www.walmart.com/" },
  ],
  dmvLocations: [
    {
      name: "Gallatin County Treasurer — Motor Vehicle Division",
      address: "311 W Main St, Room 101, Bozeman, MT 59715",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. About 10 minutes from Belgrade.",
      featured: true,
    },
    {
      name: "Montana MVD — Bozeman Driver Exam Station",
      address: "3810 Valley Commons Dr, Suite 3, Bozeman, MT 59718",
      hours: "Mon–Fri, 7:30 AM – 5:00 PM (by appointment)",
      note: "Driver license testing and renewals. REAL ID available. Appointment required — book weeks ahead.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "BZN",
      name: "Bozeman Yellowstone International Airport",
      distance: "Located in Belgrade — 2 miles from downtown Belgrade",
      address: "850 Gallatin Field Rd, Belgrade, MT 59714",
      note: "Montana's busiest airport — over 2 million passengers annually. Connections to Seattle, Denver, Salt Lake City, Minneapolis, Chicago, Dallas, Los Angeles, San Francisco, and more. Year-round service from 8+ airlines including Delta, United, American, Alaska, and Southwest.",
      flightUrl: "https://www.bozemanairport.com/",
      flightLabel: "BZN Airport Website",
      featured: true,
    },
    {
      code: "HLN",
      name: "Helena Regional Airport",
      distance: "About 80 miles north of Belgrade (1 hour 20 minutes)",
      address: "2850 Skyway Dr, Helena, MT 59602",
      note: "Alternative regional airport with connections to Salt Lake City, Denver, Seattle, and Minneapolis. Backup option if BZN flights are unavailable.",
      flightUrl: "https://helenaairport.com/",
      flightLabel: "Helena Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified Montana birth certificates from the Montana DPHHS Vital Records. Online, mail, or in-person options for Gallatin County.",
      url: "https://dphhs.mt.gov/vitalrecords/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through Montana DPHHS Vital Records. Required for estate and legal matters in Gallatin County.",
      url: "https://dphhs.mt.gov/vitalrecords/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Gallatin County Clerk & Recorder. Certified copies available at the Bozeman courthouse.",
      url: "https://www.gallatin.mt.gov/Departments/Clerk-Recorder",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Gallatin County District Court. Required for name change passport corrections.",
      url: "https://www.gallatin.mt.gov/Departments/Clerk-Recorder",
    },
  ],
};